export function DemoBadge({ className = "" }) {
  return (
    <span
      data-testid="demo-badge"
      className={`inline-flex items-center gap-1.5 rounded-md bg-warning/15 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-warning ring-1 ring-warning/30 ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-warning animate-pulse" />
      Demo Data
    </span>
  );
}
